var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rss-widget",style:(_vm.style)},[_c('RssViewer',{attrs:{"setting":_vm.rssSetting}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }